import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";

import { AnimatedStackItem as AnimatedStackItemType } from "../types";

export const AnimatedStackItem = ({
  item,
  activeItemKeys,
}: {
  item: AnimatedStackItemType;
  activeItemKeys: string[];
}) => {
  const isTopItem = item.key === activeItemKeys[activeItemKeys.length - 1];

  const animatedStyle: StyleProp<ViewStyle> = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    top: 0,
    height: "100%",
    flex: 1,
    pointerEvents: isTopItem ? "auto" : "none",
    zIndex: 1,
    opacity: isTopItem ? 1 : 0,
  };

  return (
    <View
      key={item.key}
      testID={`animated-stack-item-${item.key}`}
      style={animatedStyle}
    >
      {isTopItem && item.render()}
    </View>
  );
};
